var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C5.33351 0 2.35072 2.98279 2.35072 6.64928C2.35072 7.85632 2.89205 9.1545 2.91473 9.20926C3.08957 9.62425 3.43455 10.2688 3.68331 10.6467L8.24237 17.5545C8.42894 17.8377 8.70508 18 9 18C9.29491 18 9.57105 17.8377 9.75763 17.5549L14.3171 10.6467C14.5662 10.2688 14.9108 9.62425 15.0857 9.20926C15.1083 9.15489 15.6493 7.85671 15.6493 6.64928C15.6493 2.98279 12.6665 0 9 0ZM14.3644 8.90574C14.2083 9.27771 13.8872 9.87731 13.6639 10.216L9.10443 17.1243C9.01447 17.2608 8.98592 17.2608 8.89596 17.1243L4.3365 10.216C4.11317 9.87731 3.79205 9.27731 3.63598 8.90534C3.62933 8.88931 3.13298 7.69439 3.13298 6.64928C3.13298 3.41421 5.76493 0.782269 9 0.782269C12.2351 0.782269 14.867 3.41421 14.867 6.64928C14.867 7.69596 14.3695 8.894 14.3644 8.90574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 3.12952C7.0588 3.12952 5.47979 4.70892 5.47979 6.64972C5.47979 8.59053 7.0588 10.1699 9 10.1699C10.9412 10.1699 12.5202 8.59053 12.5202 6.64972C12.5202 4.70892 10.9412 3.12952 9 3.12952ZM9 9.38766C7.49061 9.38766 6.26206 8.1595 6.26206 6.64972C6.26206 5.13995 7.49061 3.91179 9 3.91179C10.5094 3.91179 11.7379 5.13995 11.7379 6.64972C11.7379 8.1595 10.5094 9.38766 9 9.38766Z",
    fill: "black"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.63d0adb059c12534ff0fcd5a8b4e479f.svg";
export { ForwardRef as ReactComponent };